// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"bodyWrapper--mp-jF_fG","noReviewsContainer":"noReviewsContainer--mp-N7Lhl","noReviewsSubHeader":"noReviewsSubHeader--mp-FZVnk","bodyImage":"bodyImage--mp-pRl8z"};